import { main, promotionAPI, storeAPI, productAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import dayjs from 'dayjs';
import { timezoneDate } from '@/common/utils/DateManager';

const createPositionCacheKey = (position = {}) => {
  const latitude = Number(position?.latitude ?? 0).toFixed(6);
  const longitude = Number(position?.longitude ?? 0).toFixed(6);
  return `${latitude}:${longitude}`;
};

export default {
  async fetchTagList({ commit }, payload = {}) {
    const response = await ServiceExec.get(main.tag, {}, { ...payload });
    if (!response || response.status !== ServiceExec.status.OK) return [];
    if (!Array.isArray(response.data)) return [];
    const data = response.data;
    commit('setTagList', data);
    commit('setCacheMeta', { tagListFetchedAt: Date.now() });
    return data;
  },
  IS_STORE_EXIST: async ({ commit, rootGetters }, payload = {}) => {
    const userPosition = rootGetters['user/getUserPosition'];
    const response = await ServiceExec.get(main.isStoreExist, userPosition, { ...payload });
    if (!response) return false;

    if (response.status === 200) {
      commit('setIsExist', response.data);
      commit('setCacheMeta', {
        locationFetchedAt: Date.now(),
        locationKey: createPositionCacheKey(userPosition)
      });
    }
  },

  /**
   * 메인 - 신규 상점리스트 조회
   * @param commit
   * @param rootGetters
   * @return {Promise<void>}
   * @constructor
   */
  FETCH_NEW_STORES: async ({ commit, rootGetters }, payload = {}) => {
    const userPosition = rootGetters['user/getUserPosition'];
    let params = { ...userPosition, page: 1, limit: 2 };
    params.startDate = dayjs(timezoneDate() - 1000 * 60 * 60 * 24 * 30).format('YYYY-MM-DD');
    params.endDate = dayjs(timezoneDate()).format('YYYY-MM-DD');

    const { data, status } = await ServiceExec.get(storeAPI.storeList, params, { ...payload });

    if (status === ServiceExec.status.OK) {
      const { list } = data;
      commit('setStoreList', list);
    }
  },
  async fetchStoreCategoryList({ commit }, payload = {}) {
    const response = await ServiceExec.get(main.storeCategory, {}, { ...payload });
    if (!response || response.status !== ServiceExec.status.OK) return [];
    if (!Array.isArray(response.data)) return [];
    const data = response.data;
    commit('setCategoryList', data);
    commit('setCacheMeta', { categoryListFetchedAt: Date.now() });
    return data;
  },
  async fetchPromotionList({ state, commit, getters, rootGetters }, payload = {}) {
    const condition = getters['getCondition'];
    const { limit, totalPage } = state.pageInfo;
    if (condition.page > totalPage) return;
    const { main = false } = payload;

    const userPosition = rootGetters['user/getUserPosition'];
    const { status, data } = await ServiceExec.get(
      promotionAPI.promotionList,
      {
        page: condition.page,
        limit: main ? 2 : condition.limit,
        ...userPosition,
        main
      },
      { ...payload }
    );

    if (status !== 200) return false;
    const { pageInfo, list } = data;

    commit('setPageInfo', pageInfo);
    commit('setPage', condition.page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setPromotionList', list ?? []);
    return data;
  },
  async fetchServiceAreaList({ commit }, payload = {}) {
    const { data } = await ServiceExec.get(main.serviceArea, {}, { ...payload });
    commit('setServiceAreaList', data);
    return data;
  },
  async fetchProductCategoryList({ commit }, payload) {
    const { data, status } = await ServiceExec.get(productAPI.category_list, payload);
    if (status === 200) commit('setProductCategoryList', data);
    return data;
  }
};
